<template>
  <TemplateView>
    <div class="container">
      <TemplatePageGrid
        :items="freeDocumentsGroupsGrid"
        :page-data="pageData"
        :loading="loadingAnimation"
        :pagination="requestType === 'admin'"
      >
        <template v-slot:buttons>
          <DocumentsGroupModal
            v-if="
              $userCheckAccess({
                abilities: 'edit_free_documents',
              })
            "
            create
            :functionDownloadPageData="downloadPageData"
          />
        </template>
        <DocumentsGroupTable
          :items="freeDocumentsGroupsGrid"
          :functionDownloadPageData="downloadPageData"
        />
      </TemplatePageGrid>
    </div>
  </TemplateView>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import TemplateView from 'components/templates/TemplateView'
import TemplatePageGrid from 'components/templates/TemplatePageGrid'
import DocumentsGroupModal from 'components/documents/DocumentsGroupModal'
import DocumentsGroupTable from 'components/documents/DocumentsGroupTable'

export default {
  name: 'documents',
  components: {
    TemplateView,
    TemplatePageGrid,
    DocumentsGroupModal,
    DocumentsGroupTable,
  },
  data() {
    return {}
  },
  created() {
    this.downloadPageData()
  },
  computed: {
    ...mapGetters('freeDocumentsGroups', ['freeDocumentsGroupsGrid', 'pageData']),
    ...mapGetters(['loadingAnimation']),
    requestType() {
      return this.$route.meta.requestType
    },
  },
  watch: {
    '$route.query'() {
      this.downloadPageData()
    },
  },
  methods: {
    ...mapActions('freeDocumentsGroups', ['onFreeDocumentsGroupsGrid']),
    downloadPageData() {
      let data = {
        type: this.requestType,
      }
      if (this.requestType === 'admin') {
        data.limit = this.$route.query.limit
        data.page = this.$route.query.page
      }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      this.onFreeDocumentsGroupsGrid(data)
    },
  },
}
</script>
